import React, { useState, useEffect } from "react";
import Sidebar from "./components/Sidebar";
import { Routes, Route } from "react-router-dom";

import Workers from "./pages/workers/WorkersMaster";
import Items from "./pages/items/ItemsMaster";
import Diamonds from "./pages/diamonds/DiamondsMaster";
import MasterFiling from "./pages/master/MasterFiling";
import Ledger from "./pages/ledger/Ledger";
import MasterClear from "./pages/master/MasterClear";
import DiamondTransactions from "./pages/master/DiamondTransactions";
import DiamondLedger from "./pages/diamonds/DiamondLedger";
import IssueWax from "./pages/wax/IssueWax";
import ReceiveWax from "./pages/wax/ReceiveWax";
import CompletedWax from "./pages/wax/CompletedWax";
import CastingDoneWax from "./pages/wax/CastingDoneWax";
import ProductCategories from "./pages/admin/ProductCategories";
import WaxStoneLedger from "./pages/diamonds/WaxStoneLedger";

import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";

// 🔥 inactivity timer import
import { setupInactivityTimer } from "./utils/SessionManager";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // 🔥 start inactivity monitor ONCE
  useEffect(() => {
    setupInactivityTimer(() => {
      localStorage.clear();
      window.location.href = "/login";
    });
  }, []);

  return (
    <>
      <div style={{ display: "flex" }}>
        <Sidebar 
          isOpen={sidebarOpen} 
          closeSidebar={() => setSidebarOpen(false)} 
        />

        <div className="page-container">
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route path="/" element={<ProtectedRoute><Workers /></ProtectedRoute>} />
            <Route path="/workers" element={<ProtectedRoute><Workers /></ProtectedRoute>} />
            <Route path="/items" element={<ProtectedRoute><Items /></ProtectedRoute>} />
            <Route path="/diamonds" element={<ProtectedRoute><Diamonds /></ProtectedRoute>} />
            <Route path="/master-filing" element={<ProtectedRoute><MasterFiling /></ProtectedRoute>} />
            <Route path="/ledger" element={<ProtectedRoute><Ledger /></ProtectedRoute>} />
            <Route path="/master-clear" element={<ProtectedRoute><MasterClear /></ProtectedRoute>} />
            <Route path="/diamond-transactions" element={<ProtectedRoute><DiamondTransactions /></ProtectedRoute>} />
            <Route path="/diamond-ledger" element={<ProtectedRoute><DiamondLedger /></ProtectedRoute>} />
            <Route path="/wax-issue" element={<ProtectedRoute><IssueWax /></ProtectedRoute>} />
            <Route path="/wax-receive" element={<ProtectedRoute><ReceiveWax /></ProtectedRoute>} />
            <Route path="/wax-completed" element={<ProtectedRoute><CompletedWax /></ProtectedRoute>} />
            <Route path="/wax-casting" element={<ProtectedRoute><CastingDoneWax /></ProtectedRoute>} />
	    <Route path="/product-categories" element={<ProductCategories />} />
	    <Route path="/wax-stone-ledger" element={<WaxStoneLedger />} />

          </Routes>
        </div>
      </div>
    </>
  );
}

export default App;
